import { Disclosure } from '@headlessui/react';
import { ArrowRightIcon, ArrowDownIcon } from '@heroicons/react/outline';

const DisclosurePanel: React.FC<DisclosurePanelProps> = ({ description, title }) => {
  return (
    <Disclosure>
      {({ open }) => (
        <div className="pb-3 my-3 border-b border-gray-400">
          <Disclosure.Button className="flex items-center justify-between w-full py-3 text-lg font-medium text-gray-800">
            <span>{title}</span>
            {open ? <ArrowDownIcon className="w-5 h-5" /> : <ArrowRightIcon className="w-5 h-5" />}
          </Disclosure.Button>
          <Disclosure.Panel className="pt-4 pb-6 pr-16 text-justify text-gray-700">
            {description}
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
};

type DisclosurePanelProps = {
  description: string;
  title: string;
};

export default DisclosurePanel;
